import { SVGIcon } from '@tonic-one/react-icons';

export function DashboardSvg({ ...rest }: any) {
  return (
    <SVGIcon
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 1.79816C8.52173 2.03811 6.30171 3.1606 4.6581 4.84744L6.62346 6.81281L5.5628 7.87347L3.68896 5.99963C2.46903 7.68639 1.75 9.75922 1.75 12C1.75 12.0836 1.751 12.1669 1.75299 12.25H4.75V13.75H1.89868C2.07844 14.7956 2.41653 15.7864 2.88717 16.6974L1.55449 17.3859C0.720594 15.7717 0.25 13.9397 0.25 12C0.25 5.51065 5.51065 0.25 12 0.25C18.4893 0.25 23.75 5.51065 23.75 12C23.75 13.9397 23.2794 15.7717 22.4455 17.3859L21.1128 16.6974C21.5835 15.7864 21.9216 14.7956 22.1013 13.75H19V12.25H22.247C22.249 12.1669 22.25 12.0836 22.25 12C22.25 9.63103 21.4463 7.44977 20.0968 5.71397L17.9373 7.87346L16.8766 6.8128L19.0909 4.59853C17.3619 2.94163 15.0535 1.88463 12.5 1.76198V5H11V1.79816ZM11.7357 14.7256C11.373 14.9614 10.9244 15.0264 10.4113 14.8566C9.64154 14.6018 9.21238 13.7481 9.46714 12.9783C9.63698 12.4651 10.0422 12.101 10.512 11.9718L17.5 10.5L11.7357 14.7256ZM8 19.25V20.75H16V19.25H8Z"
      />
    </SVGIcon>
  );
}

export function XSvg({ ...rest }: any) {
  return (
    <SVGIcon
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <path d="M11 9.2L3.5 0.5H0.5L9.5 11L0.5 21.5H3.5L12.5 11L11 9.2ZM21.5 0.5H18.5L13.25 6.65L14.75 8.3L21.5 0.5ZM18.5 21.5002L13.25 15.3502L14.75 13.7002L21.5 21.5002H18.5Z" />
      </g>
    </SVGIcon>
  );
}

export function PolicySvg({ ...rest }: any) {
  return (
    <SVGIcon
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <path d="M22.5 0.75V12.75V14.25V17.25H15V16.185C15 16.035 14.985 15.9 14.985 15.75H21V14.25H14.85C14.775 13.74 14.67 13.23 14.535 12.75H21V2.25H12.3C12.075 1.695 11.76 1.2 11.4 0.75H22.5ZM13.5 16.185V20.25H12V16.185C12 13.935 11.25 11.85 10.125 10.995C7.98 9.345 5.535 9.345 3.375 10.995C2.25 11.85 1.5 13.935 1.5 16.185V20.25H0V16.185C0 13.41 0.945 10.95 2.475 9.795C3.24 9.21 4.035 8.82 4.86 8.565C3.315 7.845 2.25 6.3 2.25 4.5C2.25 2.025 4.275 0 6.75 0C9.225 0 11.25 2.025 11.25 4.5C11.25 6.3 10.185 7.845 8.655 8.565C9.48 8.82 10.275 9.21 11.04 9.795C12.555 10.965 13.5 13.41 13.5 16.185ZM6.75 7.5C8.4 7.5 9.75 6.15 9.75 4.5C9.75 2.85 8.4 1.5 6.75 1.5C5.1 1.5 3.75 2.85 3.75 4.5C3.75 6.15 5.1 7.5 6.75 7.5Z" />
      </g>
    </SVGIcon>
  );
}

export function LogSvg({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M8 3.5H3.5V8H8V3.5ZM6.5 6.5H5V5H6.5V6.5ZM18.5 6.5H9.5V5H18.5V6.5ZM0.5 0.5V21.5H21.5V0.5H0.5ZM20 20H2V2H20V20ZM18.5 11.75H3.5V10.25H18.5V11.75ZM8 14H3.5V18.5H8V14ZM6.5 17H5V15.5H6.5V17ZM9.5 15.5H18.5V17H9.5V15.5Z" />
      </g>
    </SVGIcon>
  );
}

export function ReportSvg({ ...rest }: any) {
  return (
    <SVGIcon
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 20.5H18.5V6.62132L13.3787 1.5H1.5V20.5ZM14 0H0V22H20V6L14 0ZM16 17.75H4V16.25H16V17.75ZM7 10H5V15H7V10ZM9 7H11V15H9V7ZM15 5H13V15H15V5Z"
      />
    </SVGIcon>
  );
}

export function QuarantineSvg({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M0.25 0H19V1.5H1.75V20H19V21.5H0.25V0ZM5 5H21.5V16.5H5V5ZM6.5 7.40027V15H20V7.40025L13.25 12.7038L6.5 7.40027ZM7.78209 6.5L13.25 10.7962L18.7179 6.5H7.78209Z" />
      </g>
    </SVGIcon>
  );
}

export function OperationsSvg({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <svg
          width="23"
          height="21"
          viewBox="0 0 23 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H21.7363V11.3855H20.2198V2.33828L10.8681 9.82742L1.51648 2.33825V18.2169H12.5139V19.7349H0V0ZM10.8681 7.88334L2.91989 1.51807H18.8164L10.8681 7.88334ZM14.7992 10.1113L17.145 13.3749L15.383 15.1388L12.1228 12.7905C11.9649 13.242 11.8791 13.7274 11.8791 14.2329C11.8791 16.6438 13.8315 18.5983 16.2399 18.5983C16.9909 18.5983 17.6976 18.4082 18.3146 18.0735L21.238 21L23 19.2361L20.0766 16.3096C20.4108 15.692 20.6007 14.9846 20.6007 14.2329C20.6007 11.8219 18.6483 9.86747 16.2399 9.86747C15.735 9.86747 15.2502 9.95335 14.7992 10.1113Z"
            fill="currentColor"
          />
        </svg>
      </g>
    </SVGIcon>
  );
}

export function AdministrationSvg({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M13.8 24H10.2L9 21L7.65 20.4L4.65 21.75L2.1 19.2L3.45 16.2L3.15 15L0 13.8V10.2L3.15 9L3.75 7.65L2.4 4.65L4.95 2.1L7.95 3.45L9 3L10.05 0H13.8L15 3L16.35 3.6L19.35 2.25L21.9 4.8L20.55 7.8L20.85 9L24 10.2V13.95L20.85 15L20.25 16.35L21.6 19.35L19.05 21.9L16.05 20.55L15 21L13.8 24ZM11.25 22.5H12.75L13.65 19.8L16.2 18.75L18.75 19.95L19.8 18.9L18.6 16.35L19.65 13.8L22.5 12.75V11.25L19.8 10.35L18.75 7.8L19.95 5.25L18.9 4.2L16.35 5.4L13.8 4.2L12.75 1.5H11.25L10.2 4.2L7.65 5.25L5.1 4.05L4.05 5.1L5.25 7.65L4.2 10.2L1.5 11.25V12.75L4.2 13.65L5.25 16.2L4.05 18.75L5.1 19.8L7.65 18.6L10.2 19.65L11.25 22.5ZM12 15.75C9.9 15.75 8.25 14.1 8.25 12C8.25 9.9 9.9 8.25 12 8.25C14.1 8.25 15.75 9.9 15.75 12C15.75 14.1 14.1 15.75 12 15.75ZM12 9.75C10.8 9.75 9.75 10.8 9.75 12C9.75 13.2 10.8 14.25 12 14.25C13.2 14.25 14.25 13.2 14.25 12C14.25 10.8 13.2 9.75 12 9.75Z" />
      </g>
    </SVGIcon>
  );
}

export function XLogo({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M22.7577 14.8826C21.0067 12.5967 20.0217 10.7083 19.8029 10.5095C20.8973 8.12412 23.6332 5.14242 23.6332 5.14242C26.0408 2.3595 29.4334 1.26621 29.4334 1.26621C27.6824 0.172922 24.5087 0.570482 24.5087 0.570482C19.1462 1.26621 15.7537 5.3412 15.7537 5.3412C8.85904 -2.01366 0.979492 1.3656 0.979492 1.3656C3.93432 2.06133 7.21747 5.14242 7.21747 5.14242C10.1723 7.82595 11.595 10.7083 11.595 10.7083C10.1723 13.4912 7.10803 16.0753 7.10803 16.0753C4.48152 18.2619 0.979492 19.6534 0.979492 19.6534C2.51163 20.3491 6.12309 21.0448 9.62511 19.8521C13.1271 18.6595 15.7537 15.9759 15.7537 15.9759C20.1312 20.3491 24.3993 20.4485 24.3993 20.4485C27.3541 20.7466 29.5429 19.6534 29.5429 19.6534C27.3541 18.7588 26.3692 18.1625 25.3842 17.4668C24.2898 16.771 22.9766 15.0814 22.7577 14.8826Z" />
      </g>
    </SVGIcon>
  );
}

export function HelpSvg({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="64"
      height="48"
      viewBox="0 0 64 48"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.47">
        <path d="M32 13C29.8244 13 27.6977 13.6451 25.8887 14.8538C24.0798 16.0625 22.6699 17.7805 21.8373 19.7905C21.0048 21.8005 20.7869 24.0122 21.2114 26.146C21.6358 28.2798 22.6835 30.2398 24.2218 31.7782C25.7602 33.3166 27.7202 34.3642 29.854 34.7886C31.9878 35.2131 34.1995 34.9952 36.2095 34.1627C38.2195 33.3301 39.9375 31.9202 41.1462 30.1113C42.3549 28.3023 43 26.1756 43 24C42.9966 21.0837 41.8365 18.2878 39.7744 16.2256C37.7122 14.1635 34.9163 13.0034 32 13ZM32 33C30.22 33 28.4799 32.4722 26.9999 31.4832C25.5198 30.4943 24.3663 29.0887 23.6851 27.4442C23.0039 25.7996 22.8257 23.99 23.1729 22.2442C23.5202 20.4984 24.3774 18.8947 25.636 17.636C26.8947 16.3774 28.4984 15.5202 30.2442 15.1729C31.99 14.8257 33.7996 15.0039 35.4442 15.6851C37.0887 16.3663 38.4943 17.5198 39.4832 18.9999C40.4722 20.4799 41 22.22 41 24C40.9974 26.3861 40.0483 28.6738 38.361 30.361C36.6738 32.0483 34.3861 32.9974 32 33ZM33.25 29.5C33.25 29.7472 33.1767 29.9889 33.0393 30.1945C32.902 30.4 32.7068 30.5602 32.4784 30.6549C32.25 30.7495 31.9986 30.7742 31.7561 30.726C31.5137 30.6777 31.2909 30.5587 31.1161 30.3839C30.9413 30.2091 30.8223 29.9863 30.774 29.7439C30.7258 29.5014 30.7505 29.2501 30.8452 29.0216C30.9398 28.7932 31.1 28.598 31.3055 28.4607C31.5111 28.3233 31.7528 28.25 32 28.25C32.3315 28.25 32.6495 28.3817 32.8839 28.6161C33.1183 28.8505 33.25 29.1685 33.25 29.5ZM35.75 20.727C35.7461 21.2745 35.6121 21.8132 35.3589 22.2987C35.1057 22.7842 34.7407 23.2024 34.294 23.519L33.168 24.362C33.0363 24.4641 32.9299 24.5953 32.8574 24.7454C32.7849 24.8955 32.7481 25.0603 32.75 25.227V27H31.25V25.227C31.2488 24.8275 31.3402 24.4331 31.517 24.0748C31.6938 23.7165 31.9512 23.4041 32.269 23.162L33.408 22.309C33.6641 22.1314 33.8742 21.8951 34.0206 21.62C34.1671 21.3448 34.2457 21.0387 34.25 20.727C34.2317 20.1858 33.9997 19.6739 33.6048 19.3033C33.2099 18.9328 32.6843 18.7338 32.143 18.75H31.857C31.3157 18.7338 30.7901 18.9328 30.3952 19.3033C30.0003 19.6739 29.7683 20.1858 29.75 20.727V21.273H28.25V20.727C28.2687 19.7881 28.6588 18.8948 29.3349 18.2431C30.0111 17.5913 30.918 17.2342 31.857 17.25H32.143C33.082 17.2342 33.9889 17.5913 34.6651 18.2431C35.3412 18.8948 35.7313 19.7881 35.75 20.727Z" />
      </g>
    </SVGIcon>
  );
}

export function HelpSSvgSM({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.99935 0.666504C6.54896 0.666504 5.13113 1.0966 3.92517 1.90239C2.71921 2.70819 1.77928 3.8535 1.22424 5.19349C0.669193 6.53348 0.523969 8.00797 0.806927 9.4305C1.08989 10.853 1.78832 12.1597 2.8139 13.1853C3.83949 14.2109 5.14616 14.9093 6.56869 15.1923C7.99122 15.4752 9.46571 15.33 10.8057 14.775C12.1457 14.2199 13.291 13.28 14.0968 12.074C14.9026 10.8681 15.3327 9.45023 15.3327 7.99984C15.3304 6.05562 14.557 4.19169 13.1823 2.81692C11.8075 1.44215 9.94357 0.668798 7.99935 0.666504ZM7.99935 13.9998C6.81266 13.9998 5.65263 13.6479 4.66593 12.9887C3.67924 12.3294 2.9102 11.3923 2.45607 10.2959C2.00195 9.19958 1.88313 7.99318 2.11464 6.8293C2.34615 5.66541 2.9176 4.59631 3.75671 3.7572C4.59583 2.91808 5.66492 2.34664 6.82881 2.11513C7.9927 1.88361 9.1991 2.00243 10.2955 2.45656C11.3918 2.91069 12.3289 3.67972 12.9882 4.66642C13.6475 5.65311 13.9994 6.81315 13.9994 7.99984C13.9976 9.59059 13.3649 11.1157 12.24 12.2405C11.1152 13.3654 9.59011 13.9981 7.99935 13.9998ZM8.83268 11.6665C8.83268 11.8313 8.78381 11.9924 8.69224 12.1295C8.60068 12.2665 8.47053 12.3733 8.31825 12.4364C8.16598 12.4995 7.99843 12.516 7.83678 12.4838C7.67513 12.4517 7.52664 12.3723 7.4101 12.2558C7.29355 12.1392 7.21418 11.9907 7.18203 11.8291C7.14988 11.6674 7.16638 11.4999 7.22945 11.3476C7.29253 11.1953 7.39934 11.0652 7.53638 10.9736C7.67342 10.882 7.83453 10.8332 7.99935 10.8332C8.22037 10.8332 8.43233 10.921 8.58861 11.0772C8.74489 11.2335 8.83268 11.4455 8.83268 11.6665ZM10.4994 5.81784C10.4968 6.18284 10.4074 6.54198 10.2386 6.86563C10.0698 7.18927 9.8265 7.46813 9.52868 7.67917L8.77802 8.24117C8.69018 8.30924 8.61931 8.39673 8.57096 8.49678C8.52262 8.59683 8.4981 8.70672 8.49935 8.81784V9.99984H7.49935V8.81784C7.49855 8.55149 7.55946 8.28857 7.67733 8.04972C7.7952 7.81086 7.9668 7.60257 8.17869 7.44117L8.93802 6.8725C9.10878 6.75408 9.2488 6.5966 9.34643 6.41316C9.44406 6.22972 9.49649 6.02562 9.49935 5.81784C9.48717 5.45703 9.33251 5.11574 9.06924 4.86872C8.80597 4.62169 8.45554 4.48905 8.09468 4.49984H7.90402C7.54316 4.48905 7.19274 4.62169 6.92947 4.86872C6.6662 5.11574 6.51154 5.45703 6.49935 5.81784V6.18184H5.49935V5.81784C5.51179 5.19188 5.77189 4.59639 6.22264 4.16189C6.6734 3.72738 7.27803 3.4893 7.90402 3.49984H8.09468C8.72067 3.4893 9.32531 3.72738 9.77606 4.16189C10.2268 4.59639 10.4869 5.19188 10.4994 5.81784Z" />
    </SVGIcon>
  );
}

export function RightSvg({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="64"
      height="48"
      viewBox="0 0 64 48"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.47">
        <path d="M25.929 16L30.475 24L25.929 32H28.23L32.775 24L28.23 16H25.929Z" />
        <path d="M34.6549 16H33.5039L38.0499 24L33.5039 32H34.6549L39.1999 24L34.6549 16Z" />
      </g>
    </SVGIcon>
  );
}

export function LeftSvg({ ...rest }: any) {
  return (
    <SVGIcon
      {...rest}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.04688 0.666504L6.01621 5.99984L9.04688 11.3332H7.51288L4.48288 5.99984L7.51288 0.666504H9.04688Z" />
      <path d="M3.22953 0.666504H3.99687L0.966201 5.99984L3.99687 11.3332H3.22953L0.199533 5.99984L3.22953 0.666504Z" />
    </SVGIcon>
  );
}
